/** Normalize Vietnamese text for case- and diacritics-insensitive matching. */
export function foldVietnamese(input: string): string {
    return input
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .trim()
        .replace(/\s+/g, ' ')
}
